<template>
  <div class="v-qrcode d-none d-print-block">
    <vue-qrcode :value="currentUrl" :margin="0" :scale="2" />
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";

export default {
  components: {
    "vue-qrcode": VueQrcode
  },
  computed: {
    currentUrl() {
      return document.location.href;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-qrcode {
  position: absolute;
  right: 10px;
  top: -120px;
  z-index: 10000;
}
</style>
